import { render, staticRenderFns } from "./NodeAutoScale.vue?vue&type=template&id=5f3fb8ec&scoped=true&"
import script from "./NodeAutoScale.vue?vue&type=script&lang=js&"
export * from "./NodeAutoScale.vue?vue&type=script&lang=js&"
import style0 from "./NodeAutoScale.vue?vue&type=style&index=0&id=5f3fb8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fb8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3fb8ec')) {
      api.createRecord('5f3fb8ec', component.options)
    } else {
      api.reload('5f3fb8ec', component.options)
    }
    module.hot.accept("./NodeAutoScale.vue?vue&type=template&id=5f3fb8ec&scoped=true&", function () {
      api.rerender('5f3fb8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autonomous/NodeAutoScale.vue"
export default component.exports